import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModalDeletarBottomComponent } from "./modal-deletar-bottom.component";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  declarations: [ModalDeletarBottomComponent],
  imports: [CommonModule, NgbDropdownModule],
  exports: [ModalDeletarBottomComponent],
})
export class ModalDeletarBottomModule {}
